const vi = {
    9000001: "Cúp Giáng Sinh 2023",
    9000002: "Giải vô địch SuperEx Futures",
    9000003: "Tổng giải thưởng cuộc thi trị giá 30.000 USDT",
    9000004: "Số người tham gia cuộc thi",
    9000005: "Đã mở khóa hồ bơi giải thưởng (USDT)",
    9000006: "Vòng loại xếp hạng khối lượng giao dịch ",
    9000007: "Cuộc thi xếp hạng tỷ suất lợi nhuận ",
    9000008: "Cuộc thi xếp hạng lợi nhuận",
    9000009: `Cuộc thi xếp hạng khối lượng giao dịch: Mở khóa giải thưởng cao nhất là quỹ tiền thưởng <span style="color: #ffc72b;">20,000</span> USDT`,
    9000010: "Theo số lượng người tham gia, số lượng người tham gia càng lớn thì tổng giải thưởng sẽ được mở khóa càng lớn, lên tới 20.000USDT",
    9000011: "Số tiền trong hũ thưởng",
    9000012: "Trong suốt thời gian diễn ra sự kiện, cập nhật hàng ngày vào lúc 10:00 (UTC)",
    9000013: "Ước tính phần thưởng",
    9000014: "Khối lượng giao dịch hợp đồng tương lai tích lũy",
    9000015: "Quy định về phần thưởng",
    9000016: "Theo số lượng người tham gia, số lượng người tham gia càng lớn thì tổng giải thưởng sẽ được mở khóa càng lớn, lên tới 20.000USDT",
    9000017: "Số tiền trong hũ thưởng (USDT)",
    9000018: "Xếp hạng lợi nhuận của hoạt động",
    9000019: "Đăng ký",
    9000020: "Xếp hạng doanh thu từ hoạt động",
    9000021: "Đã kết thúc",
    9000022: `Cuộc thi xếp hạng tỷ suất lợi nhuận - Nhận tiền thưởng <span style="color: #ffc72b;">{moneyPond}</span> USDT`,
    9000023: `Cuộc thi xếp hạng lợi nhuận - Nhận tiền thưởng <span style="color: #ffc72b;">{moneyPond}</span> USDT`,
    9000024: "Tỷ lệ lợi nhuận tích lũy của hợp đồng tương lai",
    9000025: "Tổng lợi nhuận hợp đồng tương lai tích lũy",
    9000026: "Chưa bắt đầu",
    9000027: "50 người tham gia hàng đầu trong cuộc thi xếp hạng lợi nhuận sẽ được trao thưởng. Để biết chi tiết, vui lòng tham khảo quy tắc phần thưởng xếp hạng để nhận phần thưởng.",
    9000028: "50 người tham gia đứng đầu về khả năng sinh lời sẽ được thưởng, vui lòng tham khảo Quy tắc thưởng xếp hạng giao dịch để nhận phần thưởng.",
    9000029: "Xếp hạng số lượng giao dịch của hoạt động",
    9000030: "Đăng ký thành công",
    9000031: "Tải xuống ứng dụng",
    9000032: "Trở về trang chủ",

    //合约交易积分
    9100001: 'Lưu điểm',
    9100002: 'Nhận Airdrop',
    9100003: 'Đổi phần thưởng',
    9100004: 'Số dư điểm',
    9100005: 'Chi tiết',
    9100006: 'Điểm đăng nhập',
    9100007: 'Điểm giao dịch',
    9100008: 'Điểm mời',
    9100009: 'Điểm thưởng',
    9100010: 'Rút thăm trúng thưởng',
    9100011: 'Nhận điểm',
    9100012: 'Quy tắc điểm',
    9100013: 'Chi tiết điểm',
    9100014: 'Bạn cần phải đăng ký để tham gia vào sự kiện này. Bấm để đăng ký',
    9100015: 'Đã giao dịch trong {day} ngày liên tiếp và kiếm được {num} điểm',
    9100016: 'Đã kiếm được {num} điểm hôm nay',
    9100017: 'Tổng giải thưởng điểm',
    9100018: 'Mỗi lần rút may mắn tiêu tốn {point} điểm và có thể rút tối đa {num} lần rút may mắn mỗi ngày.',
    9100019: 'Số lần rút thăm may mắn ngày hôm nay',
    9100020: 'Người dùng',
    9100021: 'Điểm',
    9100022: 'Số dư điểm không đủ',
    9100023: 'Số dư điểm không đủ. Hãy tích lũy điểm trước khi tham gia rút thăm may mắn.',
    9100024: 'Số lần rút thăm may mắn đã đạt đến giới hạn!',
    9100025: 'Số lần rút thăm may mắn ngày hôm nay đã đạt đến giới hạn. Hãy thử lại vào ngày mai.',
    9100026: 'Làm thế nào để có được điểm',
    9100027: 'Đăng ký tham gia hoạt động kiếm điểm giao dịch hợp đồng tương lai để kiếm điểm.',
    9100028: 'Đăng kí thành công',
    9100029: 'Bạn đã đăng ký tham gia hoạt động giao dịch hợp đồng tương lai để kiếm điểm. Đi và giao dịch để kiếm thêm điểm (bạn sẽ không còn được hưởng phần thưởng hoa hồng và hoàn tiền nữa)',
    9100030: 'Sau khi hủy đăng ký, bạn sẽ không nhận được điểm nữa. Bạn có chắc chắn muốn hủy đăng ký của mình không?',
    9100031: 'Trung tâm hoạt động điểm giao dịch',
    9100032: 'Nhận điểm',
    9100033: 'Bạn cần phải đăng ký để tham gia vào sự kiện này. Bấm để đăng ký',
    9100034: 'Bạn có thể kiếm điểm bằng cách giao dịch hợp đồng tương lai liên tục',
    9100035: 'Người dùng có thể kiếm điểm cho tất cả các giao dịch hợp đồng tương lai',
    9100036: 'Bảng xếp hạng điểm',
    9100037: 'Năm người dùng đứng đầu trong bảng xếp hạng giao dịch hàng ngày sẽ nhận được thêm điểm thưởng',
    9100038: 'Người dùng được mời nhận được điểm và người mời có thể nhận được điểm thưởng.',
    9100039: '{guy} Đã giành được <span style="color:#D9A31A"> {num} điểm!</span>',
    9100040: 'Hãy thử rút thăm may mắn ngay bây giờ!',
    9100041: 'Chúc mừng bạn đã nhận được',
    9100042: 'Các loại',
    9100043: 'Ở lại trang này',
    9100044: 'Đăng ký tham gia',
    9100045: 'Tiếp tục giao dịch',
    9100046: 'Hiện tại không có hoạt động nào đang diễn ra. Hãy theo dõi những tin tức mới nhất...',
    9100047: 'Đổi token SCS',
    9100048: '',
    9100049: '',

    9100050: 'Ngày',
    9100051: 'Chọn ngày bắt đầu',
    9100052: 'Chọn ngày kết thúc',
    9100053: 'đến',
    9100054: 'Loại ',

    9100055: 'Điểm kiếm được = Khối lượng giao dịch * 1% (Tỉ lệ sẽ được điều chỉnh thêm khi tổng khối lượng giao dịch của nền tảng tăng lên)',
    9100056: 'Ví dụ: người dùng sử dụng một vị thế có mức ký quỹ 100 USDT*100X=10000 USDT',
    9100057: 'Sau đó, bạn chỉ cần nạp 100 USDT để nhận được 100 điểm',
    9100058: 'Điểm giao dịch là cách duy nhất để có được token nền tảng SCS',
    9100059: 'Điểm thưởng bổ sung = tổng điểm trong ngày * tỷ lệ phần thưởng xếp hạng',
    9100060: 'Xếp hạng',
    9100061: 'Hạng nhất',
    9100062: 'Hạng hai',
    9100063: 'Hạng ba',
    9100064: 'Hạng bốn',
    9100065: 'Hạng năm',
    9100066: 'Người dùng được mời nhận được điểm và người mời có thể nhận được điểm thưởng.',
    9100067: 'Yếu tố cấp độ',
    9100068: 'Công thức tính: điểm giới thiệu thu được = điểm người được mời * hệ số cấp độ',
    9100069: 'Hệ số cấp độ sẽ được điều chỉnh theo tình hình thực tế',
    9100070: 'Ví dụ: Người dùng B tham gia vào một hoạt động tích điểm và người mời của họ là người dùng A và số lượng lời mời từ người dùng A đã đạt Cấp 3. Người dùng B đã tích lũy điểm = 360.000;',
    9100071: 'Khi đó số điểm khuyến mãi tích lũy mà người dùng A có thể nhận được = 360000* 30% = 108.000 ',
    9100072: 'Hệ số thưởng',
    9100073: '1 Người dùng giao dịch',
    9100074: 'Khối lượng giao dịch đạt tới 5 triệu',
    9100075: 'Khối lượng giao dịch đạt tới 20 triệu',

    9100076: 'Chuyển ',

    //热币
    9100080: 'Đã kết thúc',
    9100081: `Nhấp vào 'Tham gia ngay' để giành phần thưởng`,
    9100082: 'Xem quy tắc',
    9100083: 'Tham gia ngay',
    9100084: 'Hoạt động',
    9100088: 'Buôn bán',
    9100089: 'Gửi',
    9100090: 'Bạn đã đăng ký rồi.',

    9100091: 'Sự kiện này đã kết thúc, hãy đón chờ sự kiện tiếp theo!',
    9100092: 'Sự kiện chưa bắt đầu, vui lòng đợi tin tức.',
    9100093: '',
    9100094: '',

    //api key
    9100105: 'Tạo Khóa API',
    9100106: 'Xem Tài liệu API',
    9100107: 'Hệ thống giao dịch tích hợp',
    9100108: 'Tạo/Quản lý Khóa API',
    9100109: 'Triển khai API',
    9100110: 'Giao dịch và Yêu cầu',
    9100111: 'Nền tảng giao dịch tài sản số hàng đầu',
    9100112: 'Dải rộng các dịch vụ giao dịch và quản lý tài sản số để đáp ứng nhu cầu giao dịch đa dạng.',
    9100113: 'Cung cấp dịch vụ tốt hơn',
    9100114: 'Phí giao dịch ưu đãi hơn, số tiền giao dịch cao hơn, chức năng quản lý tài khoản linh hoạt hơn, v.v.',
    9100115: 'Lựa chọn của hàng triệu người dùng',
    9100116: 'Đảm bảo môi trường giao dịch an toàn, cung cấp hỗ trợ khách hàng chuyên nghiệp, giúp bạn tiến bộ ổn định trong thế giới tài sản số.',
    9100117: 'Làm thế nào để tạo Khóa API tại SuperEx?',
    9100118: 'Tài liệu API SuperEx có thể xem ở đâu?',
    9100119: 'Làm gì nếu gặp sự cố giao dịch với SuperEx?',
    9100120: 'Làm thế nào để sử dụng API của SuperEx?',
    9100121: 'Truy cập API SuperEx để giao dịch nhanh hơn và trơn tru hơn',
    9100122: `Khi bạn đã đăng nhập, di chuột lên hình đại diện - 'Quản lý API' và nhấp 'Tạo Khóa API' để tạo Khóa API của bạn tại SuperEx. Lưu ý: Nếu bạn chưa đăng nhập, bạn cần đăng nhập vào tài khoản SuperEx của mình trước.
Bạn cũng có thể tạo Khóa API của mình từ liên kết 'APIs' trong thanh điều hướng dưới cùng.`,
    9100123: 'Bạn có thể nhấp vào <a style="color:#d1a53e;text-decoration:underline !important;font-size: 14px;font-family: Lato-Regular, Lato;font-weight: 400;" href="https://docs-api.superex.com/en/quickStart.html">Tài liệu API</a> để xem tài liệu API của SuperEx.',
    9100124: 'Nếu bạn gặp bất kỳ vấn đề nào hoặc có đề xuất trong quá trình sử dụng, bạn có thể liên hệ với chúng tôi theo các cách sau: <br>Liên hệ với dịch vụ khách hàng thông qua "Trung tâm Trợ giúp" trên trang web chính thức hoặc gửi email đến support@superex.com.',
    9100125: `Để sử dụng API của SuperEx, bạn đầu tiên cần:<br>
Đăng ký và đăng nhập vào tài khoản SuperEx của mình.<br>
Tạo một Khóa API, sẽ tạo ra access_key và secret_key cho bạn.<br>
Sử dụng access_key và secret_key này để ký các yêu cầu của bạn.<br>
Tùy thuộc vào nhu cầu của bạn, bạn có thể sử dụng các API khác nhau do SuperEx cung cấp, chẳng hạn như API Dữ liệu Thị trường, API Giao dịch, và API Tài khoản. Đảm bảo mỗi yêu cầu tuân theo hướng dẫn trong tài liệu API, có đầu HTTP và chữ ký thích hợp.`,
    9100126: 'Hành động',
    9100127: 'Tạo Khóa API Mới',
    9100128: 'Tên Khóa API',
    9100129: 'Vui lòng nhập Tên Khóa API',
    9100130: 'Quyền (Lựa chọn nhiều)',
    9100131: 'Đọc',
    9100132: 'Giao dịch',
    9100133: 'Danh sách cho phép địa chỉ IP (tùy chọn)',
    9100134: 'Bạn có thể liên kết tới 10 địa chỉ IP với mỗi Khóa API, được tách biệt bằng dấu phẩy.',
    9100135: 'Tôi đã đọc và đồng ý với',
    9100136: 'Tôi đã đọc và đồng ý với Thông báo Rủi ro Người dùng API',
    9100137: 'Tạo',
    9100138: 'SuperEx cung cấp cho bạn một API mạnh mẽ cho phép bạn sử dụng các dịch vụ như truy vấn thị trường và giao dịch tự động. Xem cách sử dụng bằng cách xem <a style="color:#0052D9;font-size: 14px;font-family: Lato-Regular, Lato;font-weight: 400;text-decoration:underline !important;color:#d1a53e;" href="https://docs-api.superex.com/en/quickStart.html">Tài liệu API</a>.',
    9100139: 'Mỗi tài khoản có thể tạo tối đa 10 Khóa API.',
    9100140: `Khóa API không được liên kết với IP sẽ tự động hết hạn sau 90 ngày. Nếu bạn có ý định sử dụng lâu dài, bạn có thể gia hạn Khóa API của mình dưới 'Khóa API của Tôi' - 'Hành động' - 'Gia hạn', kéo dài thời hạn thêm 90 ngày nữa. Khóa API được liên kết với IP không có giới hạn thời gian hết hạn.`,
    9100141: 'Khóa API của Tôi',
    9100142: 'Quyền',
    9100143: 'Địa chỉ IP',
    9100144: 'Gia hạn',
    9100145: 'Việc tạo Khóa API yêu cầu bạn nạp một khoản tiền bất kỳ vào ví giao dịch để kích hoạt tài khoản',
    9100146: 'Xác nhận gia hạn Khóa API hiện tại',
    9100147: 'Không tiết lộ Khóa Truy cập và Khóa Bí mật của bạn để tránh mất tài sản.',
    9100148: 'Vì lý do an ninh, khuyến nghị liên kết Khóa API với các địa chỉ IP cụ thể. Một Khóa API có thể được liên kết với tối đa 20 địa chỉ IP hoặc phân đoạn IP. Bạn có thể nhập một địa chỉ IP hoặc nhiều địa chỉ trực tiếp và tách các địa chỉ khác nhau bằng dấu phẩy. Ví dụ: 192.168.1.1,192.168.1.2',
    9100149: 'Sau khi gia hạn thành công, ngày hết hạn sẽ được tính toán lại. Nếu bạn sử dụng Khóa API lâu dài, khuyến nghị liên kết địa chỉ IP. Khóa API được liên kết sẽ không hết hạn và cũng an toàn hơn.',
    9100150: 'Xác nhận xóa Khóa API hiện tại?',
    9100151: 'Bạn cần hiểu các rủi ro sau:',
    9100152: 'Khóa API của bạn liên quan chặt chẽ đến an ninh tài khoản của bạn. Bất kỳ ai biết Khóa API của bạn đều có thể kiểm soát tài sản của tài khoản bạn. Do đó, vui lòng bảo vệ nó cẩn thận, không tiết lộ Khóa API của bạn cho bên thứ ba, và không tải lên các trang web hoặc diễn đàn của bên thứ ba.',
    9100153: 'Nếu Khóa API của bạn bị rò rỉ do lý do cá nhân, bao gồm nhưng không giới hạn ở các vấn đề an ninh tài sản và tổn thất kinh tế, bạn sẽ phải chịu trách nhiệm về tất cả hậu quả phát sinh từ đó và chúng tôi sẽ không chịu trách nhiệm.',
    9100154: 'Thông báo Rủi ro',
    9100155: 'Tôi nhận thức được và sẵn sàng chấp nhận rủi ro.',
    9100156: 'Đã lưu',
    9100157: 'Quyền',
    9100158: 'Khóa Bí mật chỉ được hiển thị một lần và không thể lấy lại nếu mất, vui lòng giữ an toàn.',
    9100159: 'Không tiết lộ Khóa Truy cập và Khóa Bí mật của bạn để tránh mất tài sản.',
    9100160: 'Nếu bạn quên Khóa Bí mật của mình, vui lòng xóa cặp khóa này và nộp đơn xin cặp mới.',
    9100161: 'Chúng tôi cung cấp API mạnh mẽ để giúp bạn tích hợp hiệu quả các tính năng giao dịch vào ứng dụng của mình. API được phân loại thành Tài khoản, Giao dịch và Dữ liệu Thị trường, cho phép bạn cấu hình các quyền cần thiết và thực hiện giao dịch tự động qua API.',
    9100162: 'Thời gian niêm yết',
    9100163: 'Tạo Khóa API Mới',
    9100164: 'Chỉnh sửa',
    9100165: 'Ngày đáo hạn',
    9100166: 'Xóa',
    9100167: 'Tạo thành công',
    9100168: 'Lời khuyên',
    9100169: 'Đồng ý',
    9100170: 'Thông báo rủi ro người dùng API',
    9100171: 'Định dạng địa chỉ IP không chính xác',
    9100172: '',
    //自由区二维码分享页面
    91000951: 'Spot Meme, thế giới tiền điện tử của người dùng, do người dùng, vì người dùng',
    91000961: 'Mở ứng dụng',
    //自由区二维码分享页面
    9100095: 'SuperEx Free Market, thế giới tiền điện tử của người dùng, do người dùng, vì người dùng',
    9100096: 'Mở ứng dụng',
    9100097: '',
    9100098: '',
}

export default vi



// WEBPACK FOOTER //
// ./src/i18n/langs/languageJame/vi.js